import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export const isNewCheckoutEnabled = () => {
  return EnterpriseExperiments.preview('wesCheckoutOptimisation');
};

export const generateImpressionForNewCheckout = () => EnterpriseExperiments.get('wesCheckoutOptimisation');

// WES Payment Gateway - BT/Stripe
export const generateImpressionForPg = () => EnterpriseExperiments.get('paymentGatewayToBeDisplayed');
export const isStripeEnabled = () =>
  EnterpriseExperiments.preview('paymentGatewayToBeDisplayed') === 'stripeEnterpriseWes';

// WES Self Serve Invoicing Flow
export const generateImpressionForSelfServeInvoicing = () => EnterpriseExperiments.get('isSelfServeInvoice');
export const previewImpressionForSelfServeInvoicing = () => EnterpriseExperiments.preview('isSelfServeInvoice');

// WES Differential Pricing
export const generateImpressionForDifferentialPricing = () => EnterpriseExperiments.get('showDifferentialPricing');
export const previewImpressionForDifferentialPricing = () => EnterpriseExperiments.preview('showDifferentialPricing');

// WES Pay by Invoice Flow
export const generateImpressionForPayByInvoice = () => EnterpriseExperiments.get('isPayByInvoiceFlowEnabled');
